// extracted by mini-css-extract-plugin
export default {"background":"pJH0tfeXhSD5k8w9DN9Z","container":"uVUBSZMI2irotegPeI1g","leaderboardTitle":"t03wYRdbq4691TQQRWue","leaderboardTableScrollBar":"rAQhpIOHMyPeefX9xOe1"};